import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { SettingService } from 'src/app/_service/setting.service';
@Component({
  selector: 'app-common-sms-setting',
  templateUrl: './common-sms-setting.component.html',
  styleUrls: ['./common-sms-setting.component.css']
})
export class CommonSmsSettingComponent implements OnInit {

  smsData: any = [];
  constructor(private sharedapi: SharedService, public settingapi: SettingService) { }

  ngOnInit(): void {
    this.getCommonSettingData();
  }
  async getCommonSettingData() {
    await this.settingapi.getcommon_setting_Data().subscribe((data: any) => {
      if (data.status) {
        this.smsData = data.smsdata;
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  onKeyValueChange(event, key_text, index) {
    let key_value;
    if (event.checked) {
      key_value = 1;
    } else {
      key_value = 0;
    }
    let value = {
      'key_text': key_text,
      'key_value': key_value
    }
    this.settingapi.updateSmsData(value).subscribe((data: any) => {
      if (data.status) {
        this.sharedapi.presentToast(data.data.replace('_', ' ').replace('_', ' ').charAt(0).toUpperCase() + data.data.replace('_', ' ').replace('_', ' ').slice(1) + ' updated successfully');
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

}
